import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';


export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const navigate = useNavigate();


  const getCheck = async () => {
    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: 'adminLogin',
        submethod: 'check',
        username: username,
        password: password,
        key: process.env.REACT_APP_KEY,
      });

      if (res.data.error) {
        return setError('Invalid Credentials');
      }

      if (res.data.status === '1') {
        localStorage.setItem('odkpfub', '5Dg4ZCDAxWoxjgGHRj6BAMQ4dUDC');
        navigate('/authentication', {
          state: { username: res.data.username, _id: res.data._id },
        });
      } else {
        setError('Invalid Credentials');
      }
    } catch (err) {
      setError('An Error Occurred. Please Try Again Later.');
      console.error(err);
    }
  };

  return (
    <div className="auth-page-wrapper pt-5">
      {/* Background Section */}
      <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
        <div className="bg-overlay" />
        <div className="shape" >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 1440 120"
          >
            <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z" />
          </svg>
        </div>
      </div>

      {/* Page Content */}
      <div className="auth-page-content" style={{ marginTop: 150 }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card mt-4 card-bg-fill">
                <div className="card-body p-4">
                  {/* Title Section */}
                  <div className="text-center mt-2">
                    {/* Dark Logo*/}
                    <a href="index.html" className="logo logo-dark">
                      <span className="logo-sm">
                        <img src="../assets/images/perfectx_web_logo_black.svg" alt="" height={22} />
                      </span>
                      <span className="logo-lg">
                        <img src="../assets/images/perfectx_web_logo.svg" alt="" height={50} />
                      </span>
                    </a>
                    {/* Light Logo*/}
                    <a href="index.html" className="logo logo-light">
                      <span className="logo-sm">
                        <img src="../assets/images/perfectx_web_logo_black.svg" alt="" height={22} />
                      </span>
                      <span className="logo-lg">
                        <img src="../assets/images/perfectx_web_logo.svg" alt="" height={50} />
                      </span>
                    </a>
                    <h5 className="text-primary">Welcome Back!</h5>
                    <p className="text-muted">Sign in to continue.</p>
                  </div>

                  {/* Form Section */}
                  <div className="auth-form">
                    <div className="form-group">
                      <label className="form-label">Username</label>
                      <input
                        type="text"
                        className="form-control"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                      />
                    </div>

                    <div className="mb-3">
                      {/* Password Input */}
                      {/* <div className="float-end">
                        <a href="/forgot-password" className="text-muted">
                          Forgot password?
                        </a>
                      </div> */}
                      <label className="form-label" htmlFor="password-input">
                        Password
                      </label>
                      <div className="position-relative auth-pass-inputgroup mb-3">
                        <input
                          type={showPassword ? 'text' : 'password'} // Toggle input type
                          id="dz-password"
                          className="form-control"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          onKeyPress={(e) => e.key === 'Enter' && getCheck()}
                        />
                        <button
                          className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon material-shadow-none"
                          type="button"
                          id="password-addon"
                          onClick={() => setShowPassword(!showPassword)} // Toggle visibility on click
                        >
                          <i
                            className={
                              showPassword
                                ? 'ri-eye-off-fill align-middle'
                                : 'ri-eye-fill align-middle'
                            }
                          />
                        </button>
                      </div>

                      {/* Error Message */}
                      {error && (
                        <div className="alert alert-danger solid alert-square">
                          {error}
                        </div>
                      )}
                    </div>

                    {/* Submit Button */}
                    <div className="mt-4">
                      <button
                        className="btn btn-success w-100"
                        type="button"
                        onClick={getCheck}
                      >
                        Sign In
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Card */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
